/**
 * Utility to dynamically update browser tab title, favicon, and SEO meta tags
 */
export function applyBranding({ title, faviconUrl, description, stammName } = {}) {
  if (typeof document === 'undefined') return;

  if (title && typeof title === 'string' && title.trim()) {
    document.title = title.trim();
  }

  const setMetaTag = (selector, content) => {
    if (!content || typeof content !== 'string') return;
    let meta = document.querySelector(selector);
    if (meta) {
      meta.setAttribute('content', content.trim());
    }
  };

  if (title) {
    setMetaTag('meta[property="og:title"]', title);
    setMetaTag('meta[name="twitter:title"]', title);
  }

  if (description) {
    setMetaTag('meta[name="description"]', description);
    setMetaTag('meta[property="og:description"]', description);
    setMetaTag('meta[name="twitter:description"]', description);
  }

  if (stammName) {
    setMetaTag('meta[property="og:site_name"]', stammName);
    setMetaTag('meta[name="author"]', stammName);
  }

  if (faviconUrl && typeof faviconUrl === 'string' && faviconUrl.trim()) {
    const cleanUrl = faviconUrl.trim();

    // Update or create standard favicon link
    let link = document.querySelector("link[rel*='icon']");
    if (!link) {
      link = document.createElement('link');
      link.rel = 'icon';
      document.head.appendChild(link);
    }
    link.href = cleanUrl;

    // Update or create apple-touch-icon
    let appleLink = document.querySelector("link[rel='apple-touch-icon']");
    if (!appleLink) {
      appleLink = document.createElement('link');
      appleLink.rel = 'apple-touch-icon';
      document.head.appendChild(appleLink);
    }
    appleLink.href = cleanUrl;
  }
}
